import * as React from 'react';
import '../../../../context/actions.js';
import '../../../../context/reducer.js';
import { useContactLensProductData } from '../../../../context/product-context-hooks.js';
import '../../../../context/ProductContext.js';
import '../../../../context/CmsContext.js';
import '@grandvisionhq/state';
import '../../../../hooks/useCartDiscountsQuery/types.js';
import '@grandvisionhq/graphql';
import '../../../../operations/queries/get-accessories-by-slug.js';
import '../../../../operations/queries/get-contact-lens-by-slug.js';
import '../../../../operations/queries/get-frames-by-slug.js';
import '../../../../operations/queries/get-solutions-by-slug.js';
import '../../../../operations/queries/get-sunglasses-by-slug.js';
import '../../../../operations/queries/get-ready-reader-by-slug.js';
import '../../../../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import '../../../../operations/queries/get-manufacturer-by-key.js';
import '@grandvisionhq/utils';
import '../../../../hooks/use-product-view-history.js';
import '@grandvisionhq/frk-routing';
import 'classnames';
import '@grandvisionhq/common';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/elements';
import '@grandvisionhq/icons';
import '@grandvisionhq/forms';
import '@grandvisionhq/analytics';
import '@swc/helpers';
import '../../../../types/product.js';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/svc-tealium/utils';
import { useDeliveryIntervalOptions } from '../../components/DeliveryIntervalSelect/use-delivery-interval-options.js';
import '@grandvisionhq/inventory';
import '@grandvisionhq/lib-utils-html';
import '../../../VTO/context/VtoProvider.js';
import 'usehooks-ts';
import 'use-onclickoutside';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/lib-visuals';
import '../../../../slots/context.js';
import '@grandvisionhq/content';
import { getActions } from './actions.js';
import { reducer } from './reducer.js';
import { getSelectors } from './selectors.js';
import { getInitialState } from './utils/get-initial-state.js';
import { triggerToastMessage } from './utils/trigger-toast-message.js';

const CLEcommContext = /*#__PURE__*/ React.createContext({});
const useCLEcommContext = ()=>React.useContext(CLEcommContext)
;
const CLEcommProvider = ({ children , maxOrderableQuantity: opcoConfigMaxQuantity  })=>{
    const { activeVariant , deliveryIntervalOptionsFallback  } = useContactLensProductData();
    const { maxQuantityPerVariant , availableSubscriptionIntervals  } = activeVariant;
    const { singleDeliveryIntervalOption  } = useDeliveryIntervalOptions({
        deliveryInterval: null,
        deliveryIntervalOptionsFallback,
        availableSubscriptionIntervals
    });
    const maxOrderableQuantity = !!maxQuantityPerVariant ? maxQuantityPerVariant : opcoConfigMaxQuantity;
    const initialState = React.useMemo(()=>{
        return getInitialState({
            sortedAttributesSet: activeVariant.prescriptionRanges,
            defaultDeliveryInterval: singleDeliveryIntervalOption === null || singleDeliveryIntervalOption === void 0 ? void 0 : singleDeliveryIntervalOption.value,
            maxOrderableQuantity
        });
    }, [
        activeVariant
    ]);
    const [state, dispatch] = React.useReducer(reducer, initialState);
    const actions = React.useMemo(()=>getActions(dispatch)
    , []);
    const selectors = React.useMemo(()=>getSelectors()
    , []);
    React.useDebugValue('CLEcommProvider');
    const value = {
        actions,
        state,
        selectors,
        maxOrderableQuantity,
        triggerToastMessage
    };
    return /*#__PURE__*/ React.createElement(CLEcommContext.Provider, {
        value: value
    }, children);
};

export { CLEcommContext, CLEcommProvider, useCLEcommContext };
//# sourceMappingURL=CLEcommContext.js.map
